import React, { lazy, Suspense } from "react";
import useAccess from "@hooks/useAccess";
import Loader from "@components/Ui/Loader";

const Layout = lazy(() => import("@components/Wrappers/Layout"));
const MinimalLayout = lazy(() => import("@components/Wrappers/MinimalLayout"));

const VersionedLayout = ({ children, minimal = false }) => {
    const { canBrowse } = useAccess();
    const useMinimal = minimal && !canBrowse;

    return (
        <Suspense fallback={<Loader isLoading text="Loading..." />}>
            {useMinimal
                ? <MinimalLayout>{children}</MinimalLayout>
                : <Layout>{children}</Layout>
            }
        </Suspense>
    );
};

export default VersionedLayout;
